<template>
  <v-row>

    <v-col cols="12" class="pt-2">
      <v-sheet
        outlined
        v-if="!loading">
        <v-row class="pa-4">

          <v-col 
            class="pl-4" 
            cols="12" 
            xl="6"
            md="6"
            sm="12">
            <h3 class="font-weight-regular pb-4">Color Día:</h3>

            <v-sheet
              :color="day_color"
              elevation="1"
              height="50"
              width="100%"
              class="mb-4"
            ></v-sheet>
            <v-text-field
              ref="short_name"
              v-model="day_color"
              outlined
              v-hex-color
              :maxlength="7"
              :counter="7"
              :rules="[v => /^#[0-9A-F]{6}$/.test(v || '') || 'Ingresá un color hexadecimal con formato #000000']"
              placeholder="#000000"
              label="Color"
              required
            ></v-text-field>
          </v-col>

          <v-col 
            class="pl-4" 
            cols="12" 
            xl="6"
            md="6"
            sm="12">
            <h3 class="font-weight-regular pb-4">Color de texto día:</h3>

            <v-radio-group v-model="day_dark_mode">
              <v-radio
                label="Blanco"
                :value="true"
              ></v-radio>

              <v-radio
                label="Negro"
                :value="false"
              ></v-radio>

            </v-radio-group>

          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2">
      <v-sheet
        outlined
        v-if="!loading">
        <v-row class="pa-4">
          <v-col 
            class="pl-4" 
            cols="12" 
            xl="6"
            md="6"
            sm="12">
            <h3 class="font-weight-regular pb-4">Color Eventos sin categoría:</h3>

            <v-sheet
              :color="uncategorized_event_color"
              elevation="1"
              height="50"
              width="100%"
              class="mb-4"
            ></v-sheet>
            <v-text-field
              v-model="uncategorized_event_color"
              outlined
              v-hex-color
              :maxlength="7"
              :counter="7"
              :rules="[v => /^#[0-9A-F]{6}$/.test(v || '') || 'Ingresá un color hexadecimal con formato #000000']"
              placeholder="#000000"
              label="Color"
              required
            ></v-text-field>
          </v-col>

          <v-col 
            class="pl-4" 
            cols="12" 
            xl="6"
            md="6"
            sm="12">
            <h3 class="font-weight-regular pb-4">Color Eventos presenciales:</h3>

            <v-sheet
              :color="presential_event_color"
              elevation="1"
              height="50"
              width="100%"
              class="mb-4"
            ></v-sheet>
            <v-text-field
              ref="short_name"
              v-model="presential_event_color"
              outlined
              v-hex-color
              :maxlength="7"
              :counter="7"
              :rules="[v => /^#[0-9A-F]{6}$/.test(v || '') || 'Ingresá un color hexadecimal con formato #000000']"
              placeholder="#000000"
              label="Color"
              required
            ></v-text-field>
          </v-col>

          <v-col 
            class="pl-4" 
            cols="12" 
            xl="6"
            md="6"
            sm="12">
            <h3 class="font-weight-regular pb-4">Color Eventos híbridos:</h3>

            <v-sheet
              :color="hybrid_event_color"
              elevation="1"
              height="50"
              width="100%"
              class="mb-4"
            ></v-sheet>
            <v-text-field
              v-model="hybrid_event_color"
              outlined
              v-hex-color
              :maxlength="7"
              :counter="7"
              :rules="[v => /^#[0-9A-F]{6}$/.test(v || '') || 'Ingresá un color hexadecimal con formato #000000']"
              placeholder="#000000"
              label="Color"
              required
            ></v-text-field>
          </v-col>

          <v-col 
            class="pl-4" 
            cols="12" 
            xl="6"
            md="6"
            sm="12">
            <h3 class="font-weight-regular pb-4">Color Eventos virtuales:</h3>

            <v-sheet
              :color="virtual_event_color"
              elevation="1"
              height="50"
              width="100%"
              class="mb-4"
            ></v-sheet>
            <v-text-field
              v-model="virtual_event_color"
              outlined
              v-hex-color
              :maxlength="7"
              :counter="7"
              :rules="[v => /^#[0-9A-F]{6}$/.test(v || '') || 'Ingresá un color hexadecimal con formato #000000']"
              placeholder="#000000"
              label="Color"
              required
            ></v-text-field>
          </v-col>

        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        :disabled="loading_update"
        color="primary"
        :to="{ name: 'customizationEdition', params: { id: this.edition_id }}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-btn
        depressed
        :loading="loading_update"
        color="primary"
        @click="updateCustomizationEdition()"
        >
        <v-icon left>
          mdi-content-save
        </v-icon>
        Guardar
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300">
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'customizationProgram',
    directives: {
      hexColor: {
        inserted(el) {
          const input = el.querySelector('input')
          el.hexColorInput = event => {
            if (event.target !== input) return
            const digits = input.value.replace(/[^0-9a-f]/gi, '').slice(0, 6).toUpperCase()
            input.value = digits ? '#' + digits : ''
          }
          el.addEventListener('input', el.hexColorInput, true)
        },
        unbind(el) {
          el.removeEventListener('input', el.hexColorInput, true)
          delete el.hexColorInput
        }
      }
    },
    data: () => ({
      loading:true,
      loading_update: false,
      edition_id:null,
      customization:[],

      day_color: null,
      day_dark_mode: null,

      uncategorized_event_color: null,
      presential_event_color: null,
      hybrid_event_color: null,
      virtual_event_color: null,

      error:false,
      errors:[],
    }),

    methods:{
      async getCustomization(){
        await axios.get('admin/editions/'+this.edition_id+'/customization').then(response =>{
          this.customization = response.data.data.customization
          this.day_color = response.data.data.customization.day_color
          this.day_dark_mode = (response.data.data.customization.day_dark_mode)?true:false
          this.uncategorized_event_color = response.data.data.customization.uncategorized_event_color
          this.presential_event_color = response.data.data.customization.presential_event_color
          this.hybrid_event_color = response.data.data.customization.hybrid_event_color
          this.virtual_event_color = response.data.data.customization.virtual_event_color

          this.loading=false
        }).catch(error => {
          this.loading=false
          console.log(error);
        })
      },

      async updateCustomizationEdition(){
        this.loading_update=true
        let formData= new FormData()
        formData.append('day_color', this.day_color)
        formData.append('day_dark_mode', (this.day_dark_mode) ? 1 : 0 )
        formData.append('uncategorized_event_color', this.uncategorized_event_color)
        formData.append('presential_event_color', this.presential_event_color)
        formData.append('hybrid_event_color', this.hybrid_event_color)
        formData.append('virtual_event_color', this.virtual_event_color)

        try {
          await axios({
            method: 'post',
            url: 'admin/editions/'+this.edition_id+'/customization-program',
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then( () =>{
            this.loading_btn = false
            this.$router.push({ name: 'customizationEdition', params: { edition_id: this.edition_id } })
          })
        } catch (error) {
          console.log('Response: ')
          console.error(error.response.data);
        }
      },

      onAppBarImageChange() {
        this.url_appbar_image = URL.createObjectURL(this.appbar_image);
      },

      deleteAppBarImage(){
        this.appbar_image=null
        this.url_appbar_image=null
      }
    },

    created(){
      this.edition_id = this.$route.params.edition_id;
      this.getCustomization()
    },
  }
</script>
